import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import InfoToolTip from '../../../../@shared/infoToolTip';
import { TMSRPRowProps } from '../../../types/index.types';
import formatText from './formatText';

const TableMSRPRow: FC<TMSRPRowProps> = (props) => {
  const { mrpRow, colOrdInIndex, searchTerm, showHiddenRightCells } = props;
  const { t } = useTranslation();
  const { title, description } = mrpRow || {};
  const msrpTitle = title?.value ? t('cnhi-MsrpTooltipTitle', { defaultValue: '' }) : '';
  const msrpDescription = description?.value ? t('cnhi-MsrpTooltipDescription', { defaultValue: '' }) : '';

  return (
    <tr>
      <td className="model-detail-specification-table__left-most-cell">
        <div
          className={`
            model-detail-specification-table__left-side-accordion-spec-title
            model-detail-specification-table__left-side-accordion-spec-title--border-hidden
            model-detail-specification-table__cell-animation
          `}
        >
          <>{mrpRow.label && <span>{formatText(mrpRow.label, searchTerm)}</span>}</>
          <InfoToolTip className="model-detail-specification-table__info-icon" showIcon={!!(msrpTitle || msrpDescription)} width={300}>
            <div className="model-detail-specification-table__tooltip-wrapper">
              <h2 className="model-detail-specification-table__tooltip-title">{msrpTitle}</h2>
              <div className="model-detail-specification-table__tooltip-body">{msrpDescription}</div>
            </div>
          </InfoToolTip>
        </div>
      </td>
      {mrpRow.prices
        ?.filter((_, columnIndex) => {
          if (!showHiddenRightCells) return columnIndex <= 5;
          return true;
        })
        .map((spec, specIndex) => (
          <td
            key={`model-detail-specification-table__spec-${spec}`}
            className={`
            model-detail-specification-table__table-cell
            model-detail-specification-table__table-cell--${specIndex % 2 === 0 ? 'even' : 'odd'}
            model-detail-specification-table__table-cell--border-hidden
          `}
          >
            <div className="model-detail-specification-table__spec model-detail-specification-table__cell-animation">
              {mrpRow.prices[colOrdInIndex[specIndex]]}
            </div>
          </td>
        ))}
    </tr>
  );
};

export default TableMSRPRow;
